import { CustomerDetail } from '@/model'
import { useAtom } from 'jotai'
import { useAsyncEffect } from 'ahooks'
import { api } from '@/service'
import { useState } from 'react'
import { isLogin } from '@/utils'
import { isJA } from "@/utils/language";
import dayjs from 'dayjs'
const ActivityModal = () => {
  const [customerDetail] = useAtom(CustomerDetail)
  const [isShow, setIsShow] = useState(false)
  useAsyncEffect(async () => {
    // 1201运费返场隐藏说效果很差
    // const activityModalCloseTime = window.localStorage.getItem('activityModalCloseTime') ?? ''
    // // 未登录，并且每天只打开一次
    // if (!isLogin() && (!activityModalCloseTime || new Date(dayjs().format('YYYY-MM-DD')).getTime() > new Date(dayjs(Number(activityModalCloseTime)).format('YYYY-MM-DD')).getTime())) {
    //   const { data } = await api.market.activitySceneConfig.customerQuery()
    //   setIsShow(data?.activityInfo?.sceneType === 1 && !data.couponInfo?.endDate && location.href.includes('/media') && !location.href.includes('/media/article'))
    // } else {
    //   setIsShow(false)
    // }
  }, [customerDetail])
  return (
    isShow && isJA() &&  (
      <div>
        {/* pc */}
        <div className="fixed  bottom-[34px] right-[86px] w-[370px] h-[190px] mo:hidden z-[41]">
          <img
            src="https://static-jp.theckb.com/static-asset/activity/coupon_activity_bg.png"
            alt=""
            className="w-full h-full cursor-pointer"
            onClick={() => {
              const urlData = location.href.includes('media/article/') ? 'coupon_media_detail' : 'coupon_media_list'
              window.location.href = `/signup?utm_source=${urlData}`
            }}
          />
          <img
            src="https://static-jp.theckb.com/static-asset/activity/cashback_home_close.png"
            alt=""
            className=" absolute top-[-20px] right-0 w-[20px] h-[20px] cursor-pointer"
            onClick={() => {
              window.localStorage.setItem('activityModalCloseTime', String(new Date().getTime()))
              setIsShow(false)
            }}
          />
        </div>
        {/* h5 */}
        <div className="fixed  bottom-0 left-0 w-full  pc:hidden z-[41]">
          <img
            src="https://static-jp.theckb.com/static-asset/activity/coupon_activity_bg_h5.png"
            alt=""
            className="w-full cursor-pointer"
            onClick={() => {
              const urlData = location.href.includes('media/article/') ? 'coupon_media_detail' : 'coupon_media_list'
              window.location.href = `/signup?utm_source=${urlData}`
            }}
          />
          <img
            src="https://static-jp.theckb.com/static-asset/activity/cashback_home_close.png"
            alt=""
            className=" absolute top-[-24px] right-0 w-[20px] h-[20px] cursor-pointer"
            onClick={() => {
              window.localStorage.setItem('activityModalCloseTime', String(new Date().getTime()))
              setIsShow(false)
            }}
          />
        </div>
      </div>
    )
  )
}
export default ActivityModal
